import * as React from 'react';
import { StyledHTMLElement } from 'styletron-react';
import { styled } from 'styletron-react';

export const BackgroundStyle: React.CSSProperties = {
    backgroundColor: '#fff',
    backgroundImage: 'linear-gradient(180deg, rgba(160,200,255,0.24) 0%, rgba(160,200,255,0.0) 60px)',
    backgroundRepeat: 'repeat-x',
    minHeight: '100vh',
    minWidth: '100vw',
    overflow: 'auto',
};

export const Background = styled('div', BackgroundStyle);



// WEBPACK FOOTER //
// ./primitives/Background.tsx